<template>
  <div class="list-table">
    <div class="search">
      <el-select v-model="params.status" placeholder="状态筛选" @change="getCompanyList" clearable @clear="getCompanyList">
        <el-option label="未认证" value="1"></el-option>
        <el-option label="认证中" value="2"></el-option>
        <el-option label="认证通过" value="3"></el-option>
        <el-option label="认证失败" value="4"></el-option>
      </el-select>
    </div>

    <div class="table-box">
      <el-table :data="companyList" style="width: 100%" :header-cell-style="{color:'#B4B4B4',height:'36px',border:'none',padding:0, background:'rgba(0,77,160,0.05)'}" :row-style="{height:'48px',padding:'0',background:'rgba(0,77,160,0.05)', borderRadius:'5px'} " :cell-style=" {fontSize:'14px',padding:0,border:'none',color:'#5C5C5C'}">
        <el-table-column label="企业名称" show-overflow-tooltip>
          <template slot-scope="{row}">
            <span>{{row.enterprise.fullName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="行业" show-overflow-tooltip>
          <template slot-scope="{row}">
            <span>{{row.enterprise.industry}}</span>
          </template>
        </el-table-column>
        <el-table-column label="性质">
          <template slot-scope="{row}">
            <span>{{row.enterprise.nature}}</span>
          </template>
        </el-table-column>
        <el-table-column label="法人">
          <template slot-scope="{row}">
            <span>{{row.legalPerson.realName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人">
          <template slot-scope="{row}">
            <span>{{row.contractPerson.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态：">
          <template slot-scope="{row}">
            <span v-if="row.status==='1'">未认证</span>
            <span v-if="row.status==='2'">认证中</span>
            <span v-if="row.status==='3'">认证通过</span>
            <span v-if="row.status==='4'">认证失败</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="{row}">
            <el-button type="text" @click="checkDetail(row)">企业资料</el-button>
            <el-button type="text" @click="checkAgreement(row)">企业协议</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-button type="primary" :disabled="params.page_num==1" @click="handleUpPage">上一页</el-button>
      <el-button type="primary" @click="handleNextPage" :disabled="companyList.length<10">下一页</el-button>
    </div>

    <company-dialog :dialog-visible="companyDialog" @getCompanyList="getCompanyList"></company-dialog>

    <company-agreement :dialog-visible="companyAgreement"></company-agreement>

  </div>
</template>

<script>
import { getCompanyList } from '@/api/certify'
import CompanyDialog from './companyDialog.vue'
import CompanyAgreement from './companyAgreement.vue';
export default {
  components: {
    CompanyDialog,
    CompanyAgreement
  },
  data() {
    return {
      params: {
        page_num: 1,
        page_size: 10,
        status: ''
      },
      companyList: [],
      companyDialog: {},
      companyAgreement: {},
    }
  },
  mounted() {
    this.getCompanyList()
  },
  methods: {
    async getCompanyList() {
      const res = await getCompanyList(this.params)
      this.companyList = res.list
    },

    checkDetail(row) {
      this.companyDialog = {
        show: true,
        detailData: row
      }

    },
    checkAgreement(row){
      this.companyAgreement = {
        show: true,
        detailData: row
      }
    },
    handleUpPage() {
      this.params.page_num--
      this.getCompanyList()
    },
    handleNextPage() {
      this.params.page_num++
      this.getCompanyList()
    }
  }
}
</script>

